import React from 'react'
import ProductsInput from './productsInput'
import ProductsList from './productsList'
import "./appProduct.css"

export default function AppProducts() {
  return (
    <main className='container-fluid'>
      <div className='container'>
        <div className='col-md-10 col-lg-8 text-center mx-auto p-3 shadow' style={{borderRadius:"0 0 10px 10px", background: "rgba(255, 255, 255, 0.605)", minHeight: "550px" }}>
          <h1 className='display-4 py-2 text-success'>My Shopping List </h1>
          <ProductsInput />
          <ProductsList />
        </div>
      </div>
    </main>
  )
}
